import {default as data} from '../../package.json';

const environment = 
{
    VERSION: data.version,
    production: true,

    // getting the sesstion
    sessionRequested: true,

    apiUrl : 'https://firestonesandboxcs.cyphersystem.com',   
    courtUrl : 'https://firestonesandboxcc.cyphersystem.com'          
}

export { environment };